module.exports = __webpack_public_path__ + "img/scorecard-preview.c2bc23e8.jpg";